import { useState } from 'react';

import useTranslations from '@/i18n/useTranslations';
import GoBackButton from '@/shared-components/buttons/components/GoBackButton';

import '../../artist-help/profile/styles.css';

export default function ProfileGalleryHelpManageInventoryPage() {
  const t = useTranslations('galleries_help.manage_inventory');
  const [openSections, setOpenSections] = useState({
    overview: false,
    addEditWithdraw: false,
    navigateInventory: false,
    limitedEditions: false,
    artlists: false,
  });

  function toggleSection(sectionKey) {
    setOpenSections((previous) => ({
      ...previous,
      [sectionKey]: !previous[sectionKey],
    }));
  }

  return (
    <section className="artist-help-category gallery-help-category">
      <header className="artist-help-category__header gallery-help-category__header">
        <GoBackButton alternativeRoute="/profile/gallery-help" />
        <h1>{t('title')}</h1>
      </header>

      <div className="artist-help-category__body gallery-help-category__body">
        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('overview')}
            aria-expanded={openSections.overview}
          >
            <h2>{t('sections.overview.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.overview ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.overview && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.overview.p1')}</p>
              <p>{t('sections.overview.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('addEditWithdraw')}
            aria-expanded={openSections.addEditWithdraw}
          >
            <h2>{t('sections.add_edit_withdraw.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.addEditWithdraw ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.addEditWithdraw && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3>{t('sections.add_edit_withdraw.add.title')}</h3>
                <p>{t('sections.add_edit_withdraw.add.p1')}</p>
                <p>{t('sections.add_edit_withdraw.add.p2')}</p>
              </div>

              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3>{t('sections.add_edit_withdraw.edit.title')}</h3>
                <p>{t('sections.add_edit_withdraw.edit.p1')}</p>
                <p>{t('sections.add_edit_withdraw.edit.p2')}</p>
              </div>

              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3>{t('sections.add_edit_withdraw.withdraw.title')}</h3>
                <p>{t('sections.add_edit_withdraw.withdraw.p1')}</p>
                <p>{t('sections.add_edit_withdraw.withdraw.p2')}</p>
              </div>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('navigateInventory')}
            aria-expanded={openSections.navigateInventory}
          >
            <h2>{t('sections.navigate_inventory.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.navigateInventory ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.navigateInventory && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.navigate_inventory.intro')}</p>

              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3>{t('sections.navigate_inventory.available.title')}</h3>
                <p>{t('sections.navigate_inventory.available.p1')}</p>
              </div>

              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3>{t('sections.navigate_inventory.pending_approval.title')}</h3>
                <p>{t('sections.navigate_inventory.pending_approval.p1')}</p>
              </div>

              <div className="artist-help-category__stack gallery-help-category__stack">
                <h3>{t('sections.navigate_inventory.sold.title')}</h3>
                <p>{t('sections.navigate_inventory.sold.p1')}</p>
              </div>

              <p>{t('sections.navigate_inventory.search_hint')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('limitedEditions')}
            aria-expanded={openSections.limitedEditions}
          >
            <h2>{t('sections.limited_editions.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.limitedEditions ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.limitedEditions && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.limited_editions.intro')}</p>
              <ul>
                <li>{t('sections.limited_editions.list_1')}</li>
                <li>{t('sections.limited_editions.list_2')}</li>
                <li>{t('sections.limited_editions.list_3')}</li>
              </ul>
              <p>{t('sections.limited_editions.p1')}</p>
              <p>{t('sections.limited_editions.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('artlists')}
            aria-expanded={openSections.artlists}
          >
            <h2>{t('sections.artlists.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.artlists ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.artlists && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.artlists.p1')}</p>
              <p>{t('sections.artlists.intro_create')}</p>
              <ul>
                <li>{t('sections.artlists.list_1')}</li>
                <li>{t('sections.artlists.list_2')}</li>
                <li>{t('sections.artlists.list_3')}</li>
                <li>{t('sections.artlists.list_4')}</li>
                <li>{t('sections.artlists.list_5')}</li>
                <li>{t('sections.artlists.list_6')}</li>
              </ul>
              <p>{t('sections.artlists.p2')}</p>
            </div>
          )}
        </section>
      </div>
    </section>
  );
}
